<div
  class="catalog-breadcrumb-wrapper d-flex pr-2 py-3 px-2 px-lg-0"
  [class.catalog-breadcrumb-wrapper]="showBorder"
  *ngIf="{ sort: sortQueryParamValue$ | async } as data"
>
  <cx-generic-link
    *ngIf="!hasAreaOfUse && showAllCategoriesLink"
    class="catalog-breadcrumb-link"
    [routerUrl]="{ cxRoute: 'catalog' } | cxUrl"
    [queryParams]="{ mya: myaQueryParamValue, sort: data.sort }"
    >{{ 'catalog.categories_heading' | cxTranslate }} <i nz-icon nzType="right" class="catalog-breadcrumb-icon"></i
  ></cx-generic-link>

  <cx-generic-link
    *ngIf="hasAreaOfUse"
    class="catalog-breadcrumb-link area-of-use-link"
    [routerUrl]="{ cxRoute: 'catalog' } | cxUrl"
    [queryParams]="{
      aou: areaOfUseAllCategoriesCode,
      mya: myaQueryParamValue,
      sort: data.sort
    }"
  >
    {{ 'catalog.areaOfUse_heading' | cxTranslate }} <i nz-icon nzType="right" class="catalog-breadcrumb-icon"></i>
  </cx-generic-link>

  <ng-container *ngIf="categories.length || areaOfUseCategories.length">
    <ng-container
      *ngTemplateOutlet="
        categoriesTemplate;
        context: { $implicit: { categories: hasAreaOfUse ? areaOfUseCategories : categories, hasAreaOfUse: hasAreaOfUse } }
      "
    ></ng-container>
  </ng-container>

  <ng-template #categoriesTemplate let-data>
    <cx-generic-link
      class="catalog-breadcrumb-link"
      *ngFor="let category of data.categories"
      [url]="data.hasAreaOfUse ? getAreaOfUseCategoryUrl(category) : getCategoryUrl(category)"
    >
      {{ category.name }}
      <i nz-icon nzType="right" class="catalog-breadcrumb-icon"></i>
    </cx-generic-link>
  </ng-template>

  <ng-container *ngIf="addons.length">
    <cx-generic-link
      class="catalog-breadcrumb-link"
      *ngFor="let addon of addons"
      [routerUrl]="{ cxRoute: 'addon', params: { title: addon.title } } | cxUrl"
      [queryParams]="{ ag: addon.id, sort: data.sort }"
    >
      {{ addon.title }}
      <i nz-icon nzType="right" class="catalog-breadcrumb-icon"></i>
    </cx-generic-link>
    <cx-generic-link
      *ngIf="addonGroup && addonNode"
      class="catalog-breadcrumb-link"
      [routerUrl]="{ cxRoute: 'addon', params: { title: addonGroup.title } } | cxUrl"
      [queryParams]="{ ag: addonGroup.id, an: addonNode.id, sort: data.sort }"
    >
      {{ addonNode.title }}
      <i nz-icon nzType="right" class="catalog-breadcrumb-icon"></i>
    </cx-generic-link>
  </ng-container>

  <div *ngIf="searchResults?.freeTextSearch" class="text-search py-1 px-2 d-flex align-items-center">
    {{ searchResults.freeTextSearch }}
    <i nz-icon pyIconThemeReverse nzType="close-circle" class="ml-1" nzTheme="outline" (click)="clearSearch()"></i>
  </div>
</div>
